export type EntityLinkConfig = {
  route: (id: string) => string;
  label: string;
};

export type ParsedOrigin = {
  prefix: string;
  parentId: string;
  shortId: string;
};

export const ENTITY_PREFIX_MAP: Record<string, EntityLinkConfig> = {
  pulo_: {
    route: (id) => `/trade/scale-tickets/${id}`,
    label: 'Purchase Load',
  },
  load_: {
    route: (id) => `/trade/loads/${id}`,
    label: 'Sales Load',
  },
};

export function parseOriginTransactionItemId(
  itemId: string,
): ParsedOrigin | null {
  const colonIndex = itemId.indexOf(':');
  const parentId = colonIndex > 0 ? itemId.substring(0, colonIndex) : itemId;

  for (const prefix of Object.keys(ENTITY_PREFIX_MAP)) {
    if (parentId.startsWith(prefix)) {
      const shortId = parentId.slice(prefix.length, prefix.length + 8);
      return { prefix, parentId, shortId };
    }
  }
  return null;
}

export function getEntityRoute(originTransactionItemId: string): string | null {
  const parsed = parseOriginTransactionItemId(originTransactionItemId);
  if (!parsed) return null;

  const config = ENTITY_PREFIX_MAP[parsed.prefix];
  return config ? config.route(parsed.parentId) : null;
}

export function getEntityLabel(prefix: string): string | null {
  const config = ENTITY_PREFIX_MAP[prefix];
  return config ? config.label : null;
}
